var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-navigation-drawer',{model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}}),_c('app-main-bar',{model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}}),_c('v-content',[_c('v-fade-transition',[_c('router-view')],1)],1),_c('app-user-message'),_c('app-loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }